import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AutosBusquedaStoreService } from '../../services/store/autos-busqueda-store.service';
import { TranslateModule } from '@ngx-translate/core';
import { TipoVehiculoComponent } from '../tipo-vehiculo/tipo-vehiculo.component';
import { MarcasComponent } from "../marcas/marcas.component";
import { CaStepComponent, CaStepperComponent } from '@global-front-components/ui/stepper';
import { ModelosComponent } from '../modelos/modelos.component';

@Component({
	selector: 'app-buscar-version-manual',
	standalone: true,
	imports: [
    CommonModule,
    TipoVehiculoComponent,
	MarcasComponent, 
	ModelosComponent,
    ReactiveFormsModule,
    TranslateModule,
	CaStepComponent,
	CaStepperComponent
],
	templateUrl: './buscar-version-manual.component.html',
	styleUrls: ['./buscar-version-manual.component.scss']
})
export class BuscarVersionManualComponent implements OnInit, OnDestroy {
	@ViewChild(CaStepperComponent)
	private stepper: CaStepperComponent;

	public buscarManualForm: FormGroup;
	public idTipoVehiculoSeleccionado: number;
	public marcaSeleccionada: string;

	constructor(
			private formBuilder: FormBuilder, 
			private autosStore: AutosBusquedaStoreService,
	) { }

	ngOnDestroy(): void {
		this.buscarManualForm?.reset(); 
	}

	ngOnInit(): void {
		this.autosStore.getTiposVehiculo();		
		this.buscarManualForm = this.formBuilder.group({marca: ['',[Validators.required]]});
		this.autosStore.idTipoVehiculoSeleccionadoSubject$.subscribe({
			next: (idTipoVehiculo) => {
				this.idTipoVehiculoSeleccionado = idTipoVehiculo;
			}
		});
		this.autosStore.marcaSeleccionadaSubject$.subscribe({
			next: (marca) => {
				this.marcaSeleccionada = marca;
			}
		});
	}

	onChangeStep(index: number) {
		if (index === 0) {
			this.autosStore.limpiarMarcas();
			this.autosStore.limpiarModelos();
		} else if (index === 1) {
			this.autosStore.limpiarModelos();
		}
		this.autosStore.limpiarVersiones();
	}

	irAlPaso(index: number): void {
		if (this.stepper) {
			this.stepper.selectedIndex = index;
			this.stepper.changeStep.emit(index); 
		}
	}
}